const currency = '€';

export const currencyFormatter = (amount = 0) => {
  const formatted = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${formatted} ${currency}`;
};
